import { useEffect, useCallback } from 'react';

const useVisibilityChange = (onVisibilityChange) => {
  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'hidden') {
      onVisibilityChange('hidden');
    } else if (document.visibilityState === 'visible') {
      onVisibilityChange('visible');
    }
  }, [onVisibilityChange]);

  useEffect(() => {
    // Add visibility change listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Also handle page show/hide events for better iOS support
    window.addEventListener('pageshow', () => onVisibilityChange('visible'));
    window.addEventListener('pagehide', () => onVisibilityChange('hidden'));

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', () => onVisibilityChange('visible'));
      window.removeEventListener('pagehide', () => onVisibilityChange('hidden'));
    };
  }, [handleVisibilityChange, onVisibilityChange]);
};

export default useVisibilityChange; 